import { MetadataService } from 'oidc-client';

class CognitoMetadataService extends MetadataService {
  async getEndSessionEndpoint() {
    let endSessionEndpoint = new URL(process.env.REACT_APP_AUTH_ENDPOINT);
    if (process.env.REACT_APP_LOGOUT_URI) {
      endSessionEndpoint = new URL(await this.getTokenEndpoint());
    }

    endSessionEndpoint.pathname = 'logout';
    endSessionEndpoint.searchParams.set(
      'client_id',
      process.env.REACT_APP_CLIENT_ID,
    );

    const logoutUri = process.env.REACT_APP_LOGOUT_URI
      || `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ''
      }`;

    endSessionEndpoint.searchParams.set('logout_uri', logoutUri);

    return endSessionEndpoint.href;
  }
}
export default CognitoMetadataService;
